import axios from "axios";
import { createStore, createEffect, createEvent } from "effector";
import {getCustomUserAgent} from "../../../common/customUserAgent"
import { getUuidAndSession } from "../../../common/localStorage";
import { changeSelectedAccountId } from "../../../common/accounts2";

export interface ICounter {
  UserCanSend: boolean,
  accountId: number,
  canSend: number,
  counterTypeId: number,
  counter_time: string,
  counter_value: string,
  dateStart: string,
  dateVerification: string,
  first_value: number,
  icon: number,
  id: number,
  is_sync: number,
  last_stamp: string,
  limit_value: number,
  nameType: string,
  ndate2: string,
  period: string,
  place_name: string,
  rec_type: number,
  rec_type_str: string,
  serialNumber: string,
  serviceName: string,
  tariffZone: any,
  tariffZone_n: any,
  tariffZone_p: any,
  tariffs: number,
  unit: string
}
interface ICounterSend{
  accountId:number
  id:number
  value:number
}

export const $currAccCounters = createStore<ICounter[]>([])

export const queryCurrAccCounters = createEffect<number, ICounter[]>();

export const queryUpdateCurrAccCounters = createEffect<ICounter, ICounter[]>();

export const sendCountersValue = createEffect<ICounterSend, string>()

// Локально проставить переданное значение как показания счётчика (после успешной передачи).
// Сервер сразу после отправки в /counter/list отдаёт counter_value=0 (значение «в обработке»),
// поэтому обновляем оптимистично введённым значением.
export const setCounterValueLocal = createEvent<{ id: number; value: number }>();

$currAccCounters.on(queryCurrAccCounters.doneData, (_, val) => val);
$currAccCounters.on(queryUpdateCurrAccCounters.doneData, (_, val) => val);
$currAccCounters.on(setCounterValueLocal, (counters, { id, value }) =>
  counters.map((c) => (c.id === id ? { ...c, counter_value: String(value) } : c))
);
// При смене ЛС сразу очищаем счётчики, чтобы не оставались от прошлого ЛС, пока грузятся новые.
$currAccCounters.reset(changeSelectedAccountId);

queryUpdateCurrAccCounters.use(async (counter)=>{
  let newCounters = $currAccCounters.getState().filter(e=>e!==counter)
    await axios.post("https://izba.kras-abs.ru/api/v3/counter/values",{
      accountId:counter.accountId,
      ...getUuidAndSession(),
      counterId:counter.id
    },
    {
     headers:{
       "Custom-User-Agent": getCustomUserAgent()
     } 
    }).then(res => {
      Object.assign(counter,{last_stamp: res.data.dateUntil});
      Object.assign(counter,{counter_value: res.data.counter_value});
      newCounters.push(counter)
    })
    return newCounters

})
queryCurrAccCounters.use((accountId: number) =>
  fetch("https://izba.kras-abs.ru/api/v3/counter/list", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      "accountId" : accountId
    }),
    headers: {
      "accept": "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent()
    },
  }).then((res) => res.json())
    .then(async (res) => {
      let counters = res.counters
      // Дожидаемся дат по всем счётчикам, только потом возвращаем — иначе last_stamp приезжает гонкой после return.
      await Promise.all(counters.map((element: ICounter) =>
        axios.post("https://izba.kras-abs.ru/api/v3/counter/values",{
          accountId:accountId,
          ...getUuidAndSession(),
          counterId:element.id
        },
        {
         headers:{
           "Custom-User-Agent": getCustomUserAgent()
         }
        }).then(res => {//@ts-ignore
          Object.assign(element,{last_stamp: res.dateUntil});
        }).catch(() => {})
      ))
      return res.counters
    }) //(res?.getCompanies.companies ?? []) as ICompany[])
    .catch((err) => {
      console.log("err_c:", err)
    })
);
sendCountersValue.use(async (params)=>{
  const res = await axios.post("https://izba.kras-abs.ru/api/v3/counter/send",{
          accountId:params.accountId,
          ...getUuidAndSession(),
          counterId:params.id,
          newValue:params.value,
          valueNight:0,
          valuePeak:0
        },
        {headers:{
          "Custom-User-Agent": getCustomUserAgent()
        }}
      )
  // после успешной передачи ({success:true}) показываем переданное значение как показания счётчика
  if (res?.data?.success) setCounterValueLocal({ id: params.id, value: params.value })
  return ''
})